import { _ as H } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { QUERIES as V } from "@ucl/shared-component-foundations";
import { c as n } from "./index-8b07dec9.js";
import t, { css as e } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as C } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as s } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { ModalWindow as f, ModalHeader as c, ModalBody as N } from "./modalWindow.js";
import "./index-5d0f31c6.js";
import { jsxs as w, jsx as a } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useClient.js";
import "./disclosure.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.from-fe752fa6.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./es.array.index-of-084b82ab.js";
import "./es.string.iterator-5de8a61e.js";
import "./combineRefs-c9ad2c39.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./aria.js";
import "./iconButton.js";
import "./button.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./index-55eee02a.js";
import "./tslib.es6-59e1c9d8.js";
import "./hooks_internal.js";
import "./analytics.js";
var S = ["isOpen", "handleCloseModal", "children", "mobileMargin", "idProps", "className"], M = "82px", I = "536px", O = /* @__PURE__ */ t(f).withConfig({
  displayName: "modalVideo__StyledModalWindow",
  componentId: "sc-15egb3d-0"
})(["&.ModalVideo{", ";@media ", "{min-height:", ";}}"], function(o) {
  var i = o.theme.components.modalVideo.ModalWindow;
  return e(i);
}, V.mobile, function(o) {
  var i = o.$mobileMargin;
  return "calc(100% - " + i + " - " + i + ")";
}), B = /* @__PURE__ */ t.div.withConfig({
  displayName: "modalVideo__Container",
  componentId: "sc-15egb3d-1"
})(["", ";"], function(o) {
  var i = o.theme.components.modalVideo.Container;
  return e(i);
}), P = /* @__PURE__ */ t(c).withConfig({
  displayName: "modalVideo__StyledModalHeader",
  componentId: "sc-15egb3d-2"
})(["&.ModalVideo__header{", ";}"], function(o) {
  var i = o.theme.components.modalVideo.ModalHeader;
  return e(i);
}), W = /* @__PURE__ */ t(N).withConfig({
  displayName: "modalVideo__StyledModalBody",
  componentId: "sc-15egb3d-3"
})(["&.ModalVideo__body{", ";}"], function(o) {
  var i = o.theme.components.modalVideo.ModalBody;
  return e(i);
});
function r(o) {
  var i, d, g = o.isOpen, p = o.handleCloseModal, b = o.children, l = o.mobileMargin, h = l === void 0 ? M : l, v = o.idProps, _ = o.className, u = H(o, S), y = C({
    label: "ModalVideo"
  }), m = s(b, {
    Header: r.Header
  }, s.PickType.LAST);
  return /* @__PURE__ */ w(O, Object.assign({
    variant: "large",
    isOpen: g,
    onClose: p,
    bgOverlayColor: "rgba(0, 20, 46, 0.8)",
    $mobileMargin: h,
    className: n(["ModalVideo", _])
  }, y, u, {
    children: [/* @__PURE__ */ a(P, Object.assign({}, (i = m.Header) == null ? void 0 : i.props, {
      idProps: v,
      onClose: p,
      className: n(["ModalVideo__header", (d = m.Header) == null ? void 0 : d.props.className])
    })), /* @__PURE__ */ a(W, {
      className: "ModalVideo__body",
      children: m.rest
    })]
  }));
}
r.Header = function(o) {
  return /* @__PURE__ */ a(c, Object.assign({}, o));
};
r.Container = B;
r.mobileMargin = M;
r.tabletAndUpHeight = I;
export {
  r as ModalVideo
};
